// Personal photos provided by itz_ool — bundled locally in /public/photos/
// so they always render regardless of CDN/referer restrictions.
export const OOL_PHOTOS = [
    {
        id: "aura",
        src: "/photos/aura.jpg",
        alt: "itz_ool under cyan and pink LEDs",
        caption: "Aura mode · ON",
    },
    {
        id: "cockpit",
        src: "/photos/cockpit.jpg",
        alt: "itz_ool with aviation headset, sky in the background",
        caption: "Cockpit energy",
    },
    {
        id: "chair",
        src: "/photos/chair.jpg",
        alt: "itz_ool in the streaming chair, headset on",
        caption: "Game face. Mic hot.",
    },
    {
        id: "between",
        src: "/photos/between.jpg",
        alt: "itz_ool between streams, purple LED ambience",
        caption: "Between streams",
    },
];

export const photoById = (id) => OOL_PHOTOS.find((p) => p.id === id) || OOL_PHOTOS[0];
